import { create } from "zustand";

const getOutputBufferSettings = (state) =>
    state.chatSettings?.output_buffer ?? {};

export const selectOutputBufferWindowSeconds = (state) =>
    Number(getOutputBufferSettings(state).window_seconds);

export const selectOutputBufferMaxMessages = (state) =>
    Number(getOutputBufferSettings(state).max_messages);

export const selectOutputBufferEnabled = (state) => {
    const windowSeconds = selectOutputBufferWindowSeconds(state);
    return Number.isFinite(windowSeconds) && windowSeconds !== 0;
};

export const useGeneralChatSettingsStore = create((set) => ({
    chatSettings: {}, // { output_buffer: { window_seconds: <number>, max_messages: <number> }, ... }

    setChatSettings: (chatSettings) => set({ chatSettings })
}));